import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_inv_item_link_RowClass} from '../../../dbschema/bl_fi_inv_item_link.model';

export class KitContainerLinkModel extends BaseContainerModel {
  bl_fi_inv_item_link: bl_fi_inv_item_link_RowClass = new bl_fi_inv_item_link_RowClass();
}
